import { _obj } from "@varunsridharan/js-vars";

export default function() {
	return _obj.create( null );
}
